import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import ReactPaginate from 'react-paginate';
import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from "reactstrap";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';

const HelperMaster = () => {

    const navigate = useNavigate();
    const [helperTable, setHelperTable] = useState([]);
    const [totalPage, setTotalPage] = useState();
    const [helperFlagMasterTable, setHelperFlagMasterTable] = useState([]);
    const [flagFilter, setFlagFilter] = useState("");
    const [searchKey, setSearchKey] = useState("");


    // const onHandleFlagFilter = (e) => {
    //     const selectedValue = e.target.value;
    //     setFlagFilter(selectedValue);
    //     getHelperData(1, 10, searchKey, selectedValue);
    // };

    // Handle when a flag is selected
    const handleFlagSelect = (event, selectedOption) => {

        if (selectedOption) {
            setFlagFilter(selectedOption.helper_flag_name);
            getHelperData(1, 10, searchKey, selectedOption.helper_flag_name);
        } else {

            setFlagFilter('');
            getHelperData(1, 10, searchKey, '');
        }
    };


    const onHandleSearchKeyItem = (e) => {
        const value = e.target.value;
        setSearchKey(value);
        getHelperData(1, 10, value, flagFilter);
    }

    const onHandleAddHelper = () => {
        navigate("/addhelper")
    }

    const onHandleEditHelper = (id) => {
        let findArrayData = helperTable.find(e => e.id === id)
        navigate('/addhelper', { state: { helperId: findArrayData.id } });
    }

    const getHelperData = async (page = 1, limit = 10, searchKeyParam = '', flagFilterParam = '') => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            // Build the query params dynamically
            let queryParams = `?pageNo=${page}&limit=${limit}`;

            if (searchKeyParam && searchKeyParam.trim() !== '') {
                queryParams += `&searchKey=${encodeURIComponent(searchKeyParam.trim())}`;
            }

            if (flagFilterParam && flagFilterParam.trim() !== '') {
                queryParams += `&flagFilter=${encodeURIComponent(flagFilterParam.trim())}`;
            }

            // Final API call
            const response = await apiService.get(`/api/HelperMaster/all${queryParams}`, config);

            // Error Handling
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);;
                return;
            }

            if (response.status === true) {
                setHelperTable(response.helperMasterData);
                setTotalPage(response.totalPages)
                // Optionally, show success messages
                // toast.success(response.message);
            } else {
                toast.success(response.message);
            }

        } catch (error) {
            console.log(error);
            toast.error(`SomeThing went wrong!!`);
        }
    };



    const getHelperFlagMasterData = async (page = 1, limit = 100000, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/HelperFlagMaster/allHelperFlag?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                console.log(response.categoryMasterDetailData)
                setHelperFlagMasterTable(response.helperFlagMasterData)
                // toast.success(response.message);
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };


    useEffect(() => {
        getHelperData();
        getHelperFlagMasterData();
    }, [!helperTable]);

    const handlePageClick = (data) => {
        getHelperData(data.selected + 1, 10, searchKey, flagFilter)
    };

    const onHandleDeleteHelper = async (id) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/HelperMaster/delete?helperId=${id}`, config)
                if (response.response && response.response.data.errors) {
                    toast.success(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    // getHelperData()
                    getHelperData(1, 10, searchKey, flagFilter);

                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    };

    return (
        <>
            <Col lg="12">
                <Card className='bg-white pd-10 card-box mb-30'>
                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-card-text mr-2"></i>
                            Helper Details
                        </div>

                        <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
                            <Input id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKeyItem(e) }} />


                        </Row>

                        <Col xl={4}>
                            {/* <Input  id="search" name="search" placeholder="Search..." type="select"  className="custom-select" onChange={(e) => { onHandleFlagFilter(e) }}
                            >
                                <option value=""> Select</option>
                                {helperFlagMasterTable.map((data, index) => (
                                    <option key={index} value={data.helper_flag_name}>
                                        {data.helper_flag_name}
                                    </option>
                                ))}
                            </Input> */}

                            <Autocomplete

                                size="small"
                                autoHighlight
                                id="flagFilter"
                                name="flagFilter"
                                options={helperFlagMasterTable}
                                getOptionLabel={(option) => option.helper_flag_name || ''}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Flag"
                                    />
                                )}
                                renderOption={(props, option, state) => (
                                    <li {...props} key={state.index}>
                                        {option.helper_flag_name}
                                    </li>
                                )}
                                renderGroup={(params) => params}
                                value={
                                    helperFlagMasterTable.find(
                                        (option) => option.helper_flag_name === flagFilter
                                    ) || null
                                }
                                onChange={handleFlagSelect}
                            />
                        </Col>
                        <Button color="primary" size="bg" onClick={onHandleAddHelper}>Add</Button>
                    </CardTitle>

                    <CardBody className="">
                        <Table hover striped responsive>
                            <thead>
                                <tr>
                                    <th>S. no.</th>
                                    <th>Flag</th>
                                    <th>Label Detail</th>
                                    <th>Value Data</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {helperTable.map((item, index) => (
                                    <tr key={index}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{item.form_name}</td>
                                        <td>{item.field_name}</td>
                                        <td>{item.field_data}</td>

                                        {/* <td>
                                        {item.filter_key}</td> */}
                                        <td>
                                            <Button color="success" size="bg" onClick={() => onHandleEditHelper(item.id)}>
                                                <i className="bi bi-pencil mr-1"></i>
                                            </Button>
                                        </td>
                                        <td>
                                            <Button color="danger" size="bg" onClick={() => onHandleDeleteHelper(item.id)}>
                                                <i class="bi bi-trash"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>

                    <CardBody>
                        {/* <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={totalPage}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        /> */}

                        <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            pageCount={totalPage} // still 4000
                            marginPagesDisplayed={1} // 1 page at start & end
                            pageRangeDisplayed={2}  // visible range around selected page
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}

                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            nextClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                        />
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}

export default HelperMaster